<template>
    <v-card flat>
        <v-overlay :value="loadingClientData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeClient.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                @click="editUser"
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.EDIT)"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu
                offset-y
                bottom
                left
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.DELETE)"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Client info" | t }}
            </v-tab>
            <v-tab-item> <client-info-tab /> </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Codes" | t }}
            </v-tab>
            <v-tab-item> <client-codes-tab /> </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Contacts info" | t }}
            </v-tab>
            <v-tab-item> <contacts-info-tab /> </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Images" | t }}
                <v-chip
                    class="ml-1 pa-2"
                    outlined
                    x-small
                    color="#f41823"
                    v-if="activeClient.images && activeClient.images.length > 0"
                >
                    {{ activeClient.images.length }}
                </v-chip>
            </v-tab>
            <v-tab-item>
                <image-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ClientInfoTab from "../export-clients/clients-tab-items/client-info-tab";
import ContactsInfoTab from "../export-clients/clients-tab-items/contacts-info-tab";
import Store from "../../store";
import ImageTab from "@/pages/export-clients/clients-tab-items/image-tab";
import ClientCodesTab from "@/pages/export-clients/clients-tab-items/client-codes-tab";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "client-view",
    components: {
        ClientCodesTab,
        ImageTab,
        ClientInfoTab,
        ContactsInfoTab
    },
    data() {
        return {
            tab: 0,
            tabs: ["Client info", "Codes", "Contacts info", "Images"]
        };
    },
    mounted() {
        document.addEventListener("keydown", this.nextTab);
        Store.dispatch("ExportClientStore/getClientData", this.$route.params.clientId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    computed: {
        ...mapState("ExportClientStore", ["activeClient", "loadingClientData"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        closeDrawer() {
            this.$router.push({ name: "export-client-list" });
        },
        editUser() {
            this.$router.push({
                name: "export-client-edit",
                params: { clientId: this.$route.params.clientId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editUser();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        handleDeleteClick() {
            if (confirm("Are you sure you want to delete this client?")) {
                Store.dispatch("ExportClientStore/deleteClient", {
                    client_id: this.activeClient.id
                });
            }
        }
    }
};
</script>

<style scoped></style>
